import { clinicFragment } from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const parentClinicTemplate = gql`
    query parentClinic($parentId: MongoDbObjectId) {
        parentClinic(parentId: $parentId) {
            ...clinicFields
        }
    }
    ${clinicFragment}
`;

export const threeShapeClinicStatusTemplate = gql`
    query threeShapeClinicStatus($clinicId: MongoDbObjectId!) {
        threeShapeClinicStatus(clinicId: $clinicId) {
            enabled
            authorized
            clientId
            codeChallenge
        }
    }
`;

export const childClinicsTemplate = gql`
    query childClinics(
        $orgId: MongoDbObjectId!
        $filters: ClinicsFilters!
        $limit: Int!
        $offset: Int!
        $orderBy: String
        $orderDirection: OrderDirection
    ) {
        childClinics(
            orgId: $orgId
            filters: $filters
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            ...clinicFields
        }
    }
    ${clinicFragment}
`;
